import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { ArticleSection } from "@/types/articleEntryData.types";
import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";

const UNSUITABLE_WITH_REVIEW_REQUIRED_SECTION: ArticleSection[] = [
  ENTRY_DATA_SECTION_KEYS.ventureCapital,
];
export const useCheckReviewRequired = () => {
  const articleSection = useArticleSection();

  const checkUnsuitableWithReviewRequiredSection = (
    section: ArticleSection,
  ) => {
    return UNSUITABLE_WITH_REVIEW_REQUIRED_SECTION.includes(section);
  };

  return {
    isUnsuitableWithReviewRequired:
      checkUnsuitableWithReviewRequiredSection(articleSection),
  };
};
